import * as React from 'react';
import {
  MergeOrder,
  TopModelMergeNameTransformed,
} from '@goldwasserexchange/react-topmodel';
import { inputContextProviderContextsDefaultTopModelsObject } from '../topModels';

export function DefaultContextProviderContextsTopModelsProvider(
  props: React.PropsWithChildren<{ order?: MergeOrder }>,
) {
  const { children, order } = props;
  return (
    <TopModelMergeNameTransformed
      topModels={inputContextProviderContextsDefaultTopModelsObject}
      order={order}
    >
      {children}
    </TopModelMergeNameTransformed>
  );
}
